import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: localStorage.getItem("isLoggedIn") === "Y" ? true : false,
  hasToken: localStorage.getItem("token") ? true : false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login(state, payload) {
      // console.log(payload.payload.response);
      localStorage.setItem("isLoggedIn", "Y");
      localStorage.setItem("token", payload.payload.response.access_token);
      state.isLoggedIn = true;
    },
    loginLocal(state, payload) {
      // console.log(payload.payload.response);
      localStorage.setItem("tokenLocal", payload.payload.response.access_token);
    },
    logout(state) {
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("token");
      localStorage.removeItem("tokenLocal");
      state.isLoggedIn = false;
    },
    getProfile(state, payload) {
      state.myProfile = payload.payload.response;
    },
    alert(state, action) {
      state.error = action.payload;
    },
  },
});

export default authSlice.reducer;
export const authActions = authSlice.actions;
